"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("../constant");
/**
 * Array of all supported operators in expressions.
 */
const OperatorValue = [
    ...constant_1.ArithmeticOperator,
    ...constant_1.ComparisonOperator,
    constant_1.LogicalAndOperator,
    constant_1.LogicalOrOperator,
    constant_1.QuestionMarkOperator
];
